import React from 'react';
import Link from 'gatsby-link';
import { Container } from 'semantic-ui-react';

import './about-page.scss'

const AboutPage = () => (
  <div>
    {/* Hero */}

    <div className="about-page">
    <Container>

      <h1 className="about-page__headline">About Us</h1>

      <p>The 2018 PME-NA Local Organizing Committee is comprised of mathematics education faculty members from the University of South Carolina and Clemson University.  This year’s conference is a collaborative endeavor of these institutions.</p>

<h3>Local Organizing Committee Co-Chairs</h3>
<ul>
<li>Thomas Hodges, University of South Carolina</li>
<li>George Roy, University of South Carolina</li>
<li>Andy Tyminski, Clemson University</li>
</ul>

<p>The Steering Committee is the governing body of and is responsible for managing <a href="http://www.pmena.org/" target="_blank">PME-NA</a>. It is composed of both elected and appointed members. The Steering Committee is composed of nine members-at-large elected by the Membership, including at least one member from each of Canada, Mexico, and the United States. These members serve staggered three-year terms of office, with typically three elected each year. In addition, the Graduate Student Membership elects two graduate student members each year for a term of one year.</p>

<h3>Steering Committee Members</h3>

<p>A list of steering committee members is available at this <a href="http://www.pmena.org/steering-committee/" target="_blank">link</a>.</p>
    </Container>
    
    </div>


    {/* Footer */}
  </div>
)

export default AboutPage



// WEBPACK FOOTER //
// ./src/pages/about/index.js